import * as React from 'react';
import {ActionListItem} from 'components/UIKit/ActionListItem';
import {Dropdown} from 'components/UIKit/Dropdown';
import {UserInfo} from '../UserInfo';
import {NavItemData} from '../../types';

interface UserLinksProps {
  user: any;
  links: NavItemData[];
  ariaLabel: string;
  className?: string;
  dropdownActive: boolean;
  wrapperClassName?: string;
  onOpen: () => any;
  onClose: () => any;
}

export function UserLinks(props: UserLinksProps) {
  const {user, links, ariaLabel, dropdownActive, wrapperClassName, onOpen, onClose} = props;

  return (
    <li className={wrapperClassName}>
      <Dropdown
        active={dropdownActive}
        ariaLabel={ariaLabel}
        trigger={<UserInfo user={user} lowlight />}
        onOpen={onOpen}
        onClose={onClose}
      >
        <ul>
          {links.map((link) => (
            <a href={link.url} key={link.url}>
              <ActionListItem label={link.title} hasHoverBorder hasPaddingOffset />
            </a>
          ))}
        </ul>
      </Dropdown>
    </li>
  );
}
